export async function getTestimonials() {
    const url = "/api/v1/testimonials";
    let response = await fetch(url);
    if(response.status !== 200) {
        throw new Error("No pudimos cargar la información.");
    }

    return response.json();
}